// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoWFerror{
display:none
}
.fieldWFstatus:hover .infoWFerror{
    display:block;
    transform: translateX(2px); /* se mueve hacia la izquierda */
    transition: transform 0.5s ease;
}

`, "",{"version":3,"sources":["webpack://./src/components/workflow-components/Triggers/styles/WFstyles.css"],"names":[],"mappings":"AAAA;AACA;AACA;AACA;IACI,aAAa;IACb,0BAA0B,EAAE,gCAAgC;IAC5D,+BAA+B;AACnC","sourcesContent":[".infoWFerror{\r\ndisplay:none\r\n}\r\n.fieldWFstatus:hover .infoWFerror{\r\n    display:block;\r\n    transform: translateX(2px); /* se mueve hacia la izquierda */\r\n    transition: transform 0.5s ease;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
